import {

    Pagination,
    Table,
    TableBody,

    TableCell,
    TableContainer,
    TableFooter,
    TableHeader,
    WindmillContext,
    TableRow
} from "@windmill/react-ui";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CareLineChart from "components/chart/LineChart/CareLineChart";
import CareBarChartComponent from "components/chart/barChart/CarebareChart";
import ChartCardone from "components/chart/ChartCardone";
import SalesCardItemOne from "components/dashboard/SalesCarditem-one";
import SalesCardItemtwo from "components/dashboard/transportcarditems";
import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";

import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import sidebar from "routes/sidebar";
import DashboardServices from "services/DashboardServices";
import "../dashboardComponents/Accountsalesdashboard.css"

import overallbookingImg
    from "../../assets/caredashboardIcons/OverAllBooking.webp";
import OntourFeedbackImg
    from "../../assets/caredashboardIcons/OntourFeedbackimg.webp";
import OntourPendingFeedbackimg
    from "../../assets/caredashboardIcons/OntourPendingFeedback.webp";
import UnsubmittedFeedbackImg
    from "../../assets/caredashboardIcons/UnsubmittedFeedbackImg.webp";

import TotalEsclationImg
    from "../../assets/caredashboardIcons/TotalEsclationImg.webp";
import OpenEsclationImg
    from "../../assets/caredashboardIcons/OpenEsclationImg.webp";
import ClosedEsclationImg
    from "../../assets/caredashboardIcons/ClosedEsclationImg.webp";
import pendingEsclationImg
    from "../../assets/caredashboardIcons/pendingEsclationImg.webp";

const GRAPHTYPE = {
    week: 1,
    month: 2,
    year: 3,
};

const CareDashboard = () => {
    const { globalSetting } = useFilter();
    const { mode } = useContext(WindmillContext);
    const { currentPage, handleChangePage, lang } =
        useContext(SidebarContext);
    const { t } = useTranslation();

    const currency = globalSetting?.default_currency;

    const [view, setView] = useState("month"); // default tab
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [percentageChange, setPercentageChange] = useState(0);


    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;
    const employeeId = adminInfo?.id
    const {
        data: CareData,
        loading: loadingCareData,
        error,
    } = useAsync(() => DashboardServices.getProfileDashboard(employeeId));
    useEffect(() => {
        // console.log("Loading:", loadingCareData);
    }, [loadingCareData, CareData]);



    const formatDateDMY = (iso) => {
        if (!iso) return "-";
        return new Date(iso).toLocaleDateString("en-GB", {
            timeZone: "UTC",
        });
    };

    useEffect(() => {
        const fetchPurchaseGraph = async () => {
            try {
                setLoading(true);

                const type = GRAPHTYPE[view];
                const res = await DashboardServices.getDashboardGraphCare(type, employeeId);
                const careStats =
                    res?.data?.care_stats?.escalation_graph || [];
                const percentage =
                    res?.data?.care_stats?.percentage_change || 0;

                const normalizedData = careStats.map((item) => ({
                    label: item.label,
                    total: Number(item.count) || 0,
                }));

                setChartData(normalizedData);
                setPercentageChange(Number(percentage));
            } catch (error) {

                setChartData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchPurchaseGraph();
    }, [view, employeeId]);




    return (
        <>
            <PageTitle sidebar={sidebar().sidebar} />
            <h1
                style={{
                    color: "black",
                    fontWeight: 600,
                    fontSize: "20px",
                }}
            >
                Current Month Status
            </h1>

            <div className="grid gap-4 mb-8 md:grid-cols-4">

                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Overall Bookings"
                    Img={overallbookingImg}
                    price={CareData?.data?.counts?.current_month_bookings_count || 0}
                    className="bg-white text-black"
                    loading={loadingCareData}
                    onNavigation='/bookings'
                    current_month={true}
                    type={false}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Submitted Feedbacks"
                    Img={OntourFeedbackImg}
                    price={CareData?.data?.counts?.submitted_feedback_count || 0}
                    className="bg-white text-black"
                    loading={loadingCareData}
                    onNavigation='/clientfeedback'
                    current_month={true}
                    type={2}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2={`Unsubmitted feedbacks`}
                    Img={OntourPendingFeedbackimg}
                    price={CareData?.data?.counts?.unsubmitted_feedback_count || 0}
                    className="bg-white text-black"
                    loading={loadingCareData}
                    onNavigation='/clientfeedback'
                    current_month={true}
                    type={1}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Ontour Feedbacks"
                    Img={UnsubmittedFeedbackImg}
                    price={CareData?.data?.counts?.ontour_feedback_count || 0}
                    className="bg-white text-black"
                    loading={loadingCareData}
                    onNavigation='/ontour-feedback'
                    current_month={true}
                    cardtype={1}
                />

            </div>



            <div className="grid gap-4 md:grid-cols-4 ">
                <SalesCardItemOne
                    card_bg_color='#D7FFDE'
                    title="Total Escalations"
                    Img={TotalEsclationImg}
                    quantity={CareData?.data?.counts?.escalation_count || 0}
                    onNavigation='/ontour-feedback'
                    current_month={true}
                    type={false}
                    cardtype={2}
                />
                <SalesCardItemOne
                    card_bg_color='#FFF3D7'
                    title="Open Escalations"
                    Img={OpenEsclationImg}
                    quantity={CareData?.data?.counts?.open_escalation_count || 0}
                    onNavigation='/ontour-feedback'
                    current_month={true}
                    type={false}
                    cardtype={3}
                />
                <SalesCardItemOne
                    card_bg_color='#D7DBFF'
                    title="Closed Escalations"
                    Img={ClosedEsclationImg}
                    quantity={CareData?.data?.counts?.closed_escalation_count || 0}
                    onNavigation='/ontour-feedback'
                    current_month={true}
                    type={false}
                    cardtype={4}
                />
                <SalesCardItemOne
                    card_bg_color='#FED7FF'
                    title="Pending Ontour Feedbacks"
                    Img={pendingEsclationImg}
                    quantity={CareData?.data?.counts?.ontour_pendingfeedback_count || 0}
                    onNavigation='/ontour-feedback'
                    current_month={true}
                    type={false}
                    cardtype={5}
                />
            </div>

            <div className="flex flex-wrap justify-between my-8 w-full">
                <ChartCardone
                    cardsize='60'
                    mode={mode}
                    loading={loadingCareData}
                   
                >
                    <CareLineChart percentageChange={percentageChange}
                        view={view}
                        onViewChange={setView}
                        data={chartData}
                        loading={loading} />
                </ChartCardone>

                <ChartCardone
                    cardsize='38'
                    mode={mode}
                    loading={loadingCareData}
                 
                >
                    <CareBarChartComponent SalesReport={CareData} />
                </ChartCardone>
            </div>

            <h1 className=" font-bold mb-3 mt-1" style={{ fontSize: "24px" }}>
                Care Recent Records
            </h1>


            {loadingCareData ? (
                <TableLoading row={5} col={7} />
            ) : CareData?.data?.counts?.current_month_orders?.length > 0 ? (
                <TableContainer className="mb-5">
                    <Table>
                        <TableHeader className="text-center">
                            <tr className="text-sm">
                                <TableCell >SI.NO</TableCell>
                                <TableCell>Ref No.</TableCell>
                                <TableCell >Trip Date</TableCell>
                                <TableCell>Arrival / Departure</TableCell>
                                <TableCell>Client Name</TableCell>
                                <TableCell>Days to complete</TableCell>
                                {/* <TableCell>OnTour FeedBack</TableCell> */}
                                <TableCell>Service Type</TableCell>
                                <TableCell>Transport Manager</TableCell>

                            </tr>
                        </TableHeader>

                        <TableBody className="text-sm text-center">
                            {CareData?.data?.counts?.current_month_orders?.map((row, index) => (

                                <TableRow key={index} className="text-center">
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell >
                                        <div className="pt-2 text-blue-400">
                                            <span className="text-sm">{row.ref_no || '-'}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-center">
                                        {row.start_date && row.end_date ? (
                                            <>
                                                <div>{formatDateDMY(row.start_date || '-')}</div>
                                                <div className="pt-3">{formatDateDMY(row.end_date || '-')}</div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>
                                    <TableCell>{row.arrival_city || '-'}</TableCell>
                                    <TableCell>{row.client_name || '-'}</TableCell>
                                    <TableCell>{row.days_to_complete || '-'}</TableCell>
                                    {/* <TableCell>{row.ontour_feedback?.feedback || '-'}</TableCell> */}

                                    <TableCell>{row.package_type || '-'}</TableCell>
                                    <TableCell className="text-sm text-center">
                                        <Tooltip style={{ cursor: "pointer" }}
                                            title={row.transport_manager_number || "No mobile"}
                                            arrow
                                        >
                                            {row.transport_manager_name}
                                        </Tooltip>
                                    </TableCell>



                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NotFound title="No recent feedback found" />
            )}

        </>
    );
};

export default CareDashboard;